import React from 'react'
import { ConfigProvider } from 'antd'
import { createRoot } from 'react-dom/client'
// import * as Sentry from '@sentry/browser'

// dayjs
import dayjs from 'dayjs'
import utcPlugin from 'dayjs/plugin/utc'
import timezonePlugin from 'dayjs/plugin/timezone'
import isBetween from 'dayjs/plugin/isBetween'
import minMax from 'dayjs/plugin/minMax'
// lokalizacia pre ConfigProvider -> ant
import EN from 'antd/es/locale/en_US'
// Lokalizcia pre antd-dayjs-webpack-plugin, ktory overridne Moment -> Dayjs format v komponentoch
import 'dayjs/locale/sk'

import App from './App'
// load theme styles with webpack
import 'core-js/stable'
import 'regenerator-runtime/runtime'

// NOTE: lebo je v gitignore a az pri starte sa vytvori prvy krat a pipelina by padla
// eslint-disable-next-line import/no-unresolved
import './styles/main.css'
import './styles/global.sass'

import ErrorBoundary from './components/ErrorBoundary'

// dayjs extended plugins
dayjs.extend(isBetween)
dayjs.extend(utcPlugin)
dayjs.extend(timezonePlugin)
dayjs.extend(minMax)
dayjs.locale('sk')

// Sentry.init({
// 	dsn: 'https://2a37f51da68d47339f324dcee270315b@sentry.goodrequest.com/3',
// 	release: process.env.REACT_APP_VERSION,
// 	enabled: process.env.NODE_ENV !== 'development'
// })

const rootElement = document.getElementById('root')
const root = createRoot(rootElement as Element | DocumentFragment)

root.render(
	<ConfigProvider
		locale={EN}
		theme={{
			token: {
				colorPrimary: '#FF6B00', // orange-600
				colorPrimaryActive: '#FF6B00', // orange-600
				colorPrimaryHover: '#FF6B00',
				colorLink: '#FF6B00', // orange-600
				colorLinkHover: '#FF6B00', // orange-600
				colorText: '#4B5563', // cool-gray-600
				colorTextHeading: '#111827',
				colorTextSecondary: '#9CA3AF', // cool-gray-400
				colorTextDisabled: '#9CA3AF', // cool-gray-100
				colorPrimaryTextHover: '#FF6B00',
				colorSuccess: '#16A34A', // green-600
				colorWarning: '#D97706', // amber-600
				colorError: '#DC2626' // red-600
			}
		}}
	>
		<ErrorBoundary>
			<App />
		</ErrorBoundary>
	</ConfigProvider>
)
